import { Helmet } from "react-helmet";

interface SeoProps {
    title?: string;
    description?: string;
}

export const Seo = ({title, description}:SeoProps) => {
    return (
        <Helmet>
            <title>1881 - {!!title ? title : "Min bedrift"}</title>
            <meta name="description" content={!!description ? description : "Oversikt over dine ulike firma(er). Legge til og endre firma detaljer"} />
        </Helmet>
    );
}